export default __webpack_public_path__ + "static/media/wh-1.4f64df6b.png";